module.exports = __webpack_public_path__ + "assets/img/sidebar-5.796b0ef0.jpg";